import React, { useContext, useEffect, useState } from "react";

import Fee from "../artifacts/contracts/Fee.sol/Fee.json";
import Header from "./Navbar";
import Navigation from "./Navigation";
import { TailSpin } from "react-loader-spinner";
import { message } from "antd";
import { ethers } from "ethers";
import { AppState } from "../App";
import { useWeb3 } from "../contexts/Web3Context";
import { useTimer } from "react-timer-hook";

function MyTimer({ expiryTimestamp }) {
  const { seconds, minutes, hours } = useTimer({ expiryTimestamp });

  return (
    <div className="timer">
      {" "}
      {/* Changed from p to div */}
      <span>{hours.toString().padStart(2, "0")}</span>:
      <span>{minutes.toString().padStart(2, "0")}</span>:
      <span>{seconds.toString().padStart(2, "0")}</span>
    </div>
  );
}

const Admin = () => {
  const useAppState = useContext(AppState);
  const {
    staticContract,
    walletAddress,
    isContractReady,
    provider,
    signer,
    contractAddresses,
  } = useWeb3();
  const [loading2, setLoading2] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loading4, setLoading4] = useState(false);
  const [loading5, setLoading5] = useState(false);
  const [referrer, setReferrer] = useState("");
  const [acc, setAcc] = useState("");
  const [id2, setId2] = useState("");
  const [level, setLevel] = useState("");
  const [roayltyTime, setRoyaltyTime] = useState(0);
  const [showRoyalty, setShowRoyalty] = useState(false);
  const [royalty, setRoyalty] = useState([0, 0, 0]);
  const [royaltyUsers, setRoyaltyUsers] = useState([[0], [0], [0]]);
  const [totalRoyaltyUsers, setTotalRoyaltyUsers] = useState([0, 0, 0]);

  const convertToEther = (value) => {
    return parseFloat(ethers.formatEther(value)).toFixed(4);
  };

  useEffect(() => {
    let mounted = true;
    async function verifyNetwork() {
      try {
        if (!provider) {
          console.log("Provider not available");
          return false;
        }
        const network = await provider.getNetwork();
        console.log("Current network details:", {
          chainId: network.chainId,
          name: network.name,
          ensAddress: network.ensAddress,
        });
        // opBNB Testnet chainId is 5611 (0x15eb in hex)
        if (network.chainId.toString() !== process.env.REACT_APP_CHAIN_ID) {
          message.warning(`Please connect to ${process.env.REACT_APP_CHAIN_NAME}`);
          return false;
        }
        return true;
      } catch (error) {
        console.error("Network verification failed:", error);
        return false;
      }
    }
    async function getData() {
      if (!isContractReady || !staticContract) {
        console.log("Waiting for contract initialization...");
        return;
      }
      try {
        // Verify network first
        const isCorrectNetwork = await verifyNetwork();
        if (!isCorrectNetwork) {
          console.log(`Wrong network, please connect to ${process.env.REACT_APP_CHAIN_NAME}`);
          return;
        }
        // Add delay after network switch
        await new Promise((resolve) => setTimeout(resolve, 1000));
        // Retry logic for contract calls
        const retry = async (fn, retries = 3) => {
          try {
            return await fn();
          } catch (error) {
            if (retries > 0) {
              console.log(`Retrying... ${retries} attempts left`);
              await new Promise((resolve) => setTimeout(resolve, 1000));
              return retry(fn, retries - 1);
            }
            throw error;
          }
        };
        // Get royalty time
        setShowRoyalty(false);
        const _royaltyTime = await retry(() => staticContract.getRoyaltyTime());
        if (!mounted) return;
        setRoyaltyTime(Number(_royaltyTime));
        setShowRoyalty(true);
        // Get royalties
        const [_royalty, _royalty1, _royalty2] = await Promise.all([
          retry(() => staticContract.royalty(0)),
          retry(() => staticContract.royalty(1)),
          retry(() => staticContract.royalty(2)),
        ]);
        if (!mounted) return;
        setRoyalty([
          convertToEther(_royalty),
          convertToEther(_royalty1),
          convertToEther(_royalty2),
        ]);
        // Get royalty users
        const [_royaltyUsers, _royaltyUsers1, _royaltyUsers2] =
          await Promise.all([
            retry(() => staticContract.getRoyaltyUsers(0)),
            retry(() => staticContract.getRoyaltyUsers(1)),
            retry(() => staticContract.getRoyaltyUsers(2)),
          ]);
        if (!mounted) return;
        setTotalRoyaltyUsers([
          _royaltyUsers.length,
          _royaltyUsers1.length,
          _royaltyUsers2.length,
        ]);
        const royalty = [[], [], []];
        _royaltyUsers.forEach((user) => royalty[0].push(Number(user)));
        _royaltyUsers1.forEach((user) => royalty[1].push(Number(user)));
        _royaltyUsers2.forEach((user) => royalty[2].push(Number(user)));

        setRoyaltyUsers(royalty);
      } catch (error) {
        console.error("Error fetching data:", error);
        if (error.message.includes("network")) {
          message.error("Please check your network connection");
        } else if (error.message.includes("user rejected")) {
          message.error("Transaction rejected by user");
        } else {
          message.error(
            "Failed to fetch royalty data. Please try refreshing the page."
          );
        }
      }
    }
    getData();
    return () => {
      mounted = false;
    };
  }, [isContractReady, staticContract, provider]);

  const newRegister = async () => {
    setLoading3(true);
    try {
      if (!signer) throw new Error("Signer not available");
      const contract = staticContract.connect(signer);
      let tx = await contract.register(referrer, acc);
      await tx.wait();
      message.success("Successfully Registered");
    } catch (error) {
      console.error("Registration error:", error);
      message.error(error.reason || "Registration failed");
    }
    setLoading3(false);
  };
  const upgrade = async () => {
    setLoading(true);
    try {
      if (!signer) throw new Error("Signer not available");
      const contract = staticContract.connect(signer);
      let tx = await contract.upgrade(id2, level);
      await tx.wait();
      message.success("Successfully Upgraded");
    } catch (error) {
      console.error("Upgrade error:", error);
      message.error(error.reason || "Upgrade failed");
    }
    setLoading(false);
  };
  const distribute = async () => {
    setLoading4(true);
    try {
      if (!signer) throw new Error("Signer not available");
      const feeContract = new ethers.Contract(
        contractAddresses.fee,
        Fee.abi,
        signer
      );
      let tx = await feeContract.distribute();
      await tx.wait();
      message.success("Successfully Distributed");
    } catch (error) {
      console.error("Distribution error:", error);
      message.error(error.reason || "Distribution failed");
    }
    setLoading4(false);
  };
  const distributeRoyalty = async () => {
    setLoading5(true);
    try {
      if (!signer) throw new Error("Signer not available");
      const contract = staticContract.connect(signer);
      let tx = await contract.distributeRoyalty();
      await tx.wait();
      message.success("Successfully Distributed");
    } catch (error) {
      console.error("Royalty distribution error:", error);
      message.error(error.reason || "Royalty distribution failed");
    }
    setLoading5(false);
  };
  // Only show admin panel for specific address
  const isAdmin =
    walletAddress?.toLowerCase() ===
    process.env.REACT_APP_ADMIN_WALLET.toLowerCase();
  return (
    <div className="pb-4 text-black dark:text-white transition-colors duration-1000 min-h-screen">
      <Header />

      <div className="flex justify-center w-full px-4 mt-6">
        <div className="w-full md:w-3/4">
          <Navigation />
        </div>
      </div>
      {isAdmin ? (
        <div className="w-full">
          <div className="w-full flex flex-col items-center">
            <div className="flex flex-col w-full md:w-3/4 mt-8 px-4 md:px-0">
              <span className="font-mono font-semibold">
                Fee Contract Balance: {useAppState.bal2} BNB
              </span>
              <span className="font-mono font-semibold">
                Royalty Contract Balance: {useAppState.bal3} BNB
              </span>
            </div>
          </div>

          <div className="w-full flex flex-col items-center px-4 md:px-0">
            <div className="flex flex-col w-full md:w-3/4 mt-8">
              <span className="font-mono font-semibold">
                Distribute Admin Fee : {useAppState.bal2} BNB
              </span>
              <button
                onClick={distribute}
                className="bg-green-500 mt-2 text-white w-full px-4 py-2 text-sm font-bold rounded-sm flex justify-center items-center"
              >
                {loading4 ? (
                  <TailSpin height={16} color="white" />
                ) : (
                  <p>Distribute Fee</p>
                )}
              </button>
            </div>

            <div className="w-full flex flex-col items-center px-4 md:px-0">
              <div className="flex flex-col w-full md:w-3/4 mt-8">
                <div className="w-full flex flex-col justify-center items-center bg-whtie dark:bg-[#1e2026] dark:bg-opacity-40 rounded-lg shadow-lg p-4">
                  <p className="border-2 border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)] py-3 px-6 font-bold text-xl flex flex-col justify-center">
                    <span className="w-full text-center">Daily Royalty</span>
                    <span className="w-full text-center">Countdown</span>
                  </p>
                  {showRoyalty ? (
                    <div className="text-2xl mt-2 font-mono px-3 rounded-sm text-white font-bold">
                      {<MyTimer expiryTimestamp={roayltyTime * 1000} />}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>

            <div className="flex w-full justify-center px-4 md:p-0 mt-4">
              <div className="md:w-3/4 w-full">
                <div className="flex justify-start items-center overflow-x-auto w-full">
                  <div className="flex justify-center w-full">
                    <div
                      className={`overflow-auto max-h-40 flex justify-between items-start w-full px-2 rounded-sm`}
                    >
                      <div className="whitespace-nowrap md:ml-0">
                        <p className="flex flex-col justify-center items-center whitespace-nowrap py-1 px-3 border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)] font-medium">
                          <span>
                            L10{" "}
                            <span className="bg-white px-3 text-xs font-bold text-gray-800 ml-1">
                              {totalRoyaltyUsers[0]}
                            </span>
                          </span>{" "}
                          <span className="font-bold">
                            {royalty[0]}{" "}
                            <span className="text-[#f0c259]">BNB</span>
                          </span>
                        </p>
                        {royaltyUsers[0].map((e, i) => {
                          return (
                            <p
                              key={i}
                              className="whitespace-nowrap border-2 border-[rgba(124,240,89,0.16)] text-white bg-[rgba(124,240,89,0.14)] rounded-lg font-semibold p-1 mt-2 px-4"
                            >
                              {e}
                            </p>
                          );
                        })}
                      </div>

                      <div className="whitespace-nowrap ml-4 md:ml-0">
                        <p className="flex flex-col justify-center items-center whitespace-nowrap py-1 px-3 border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)] font-medium">
                          <span>
                            L11{" "}
                            <span className="bg-white px-3 text-xs font-bold text-gray-800 ml-1">
                              {totalRoyaltyUsers[1]}
                            </span>
                          </span>{" "}
                          <span className="font-bold">
                            {royalty[1]}{" "}
                            <span className="text-[#f0c259]">BNB</span>
                          </span>
                        </p>
                        {royaltyUsers[1].map((e, i) => {
                          return (
                            <p
                              key={i}
                              className="whitespace-nowrap border-2 border-[rgba(124,240,89,0.16)] text-white bg-[rgba(124,240,89,0.14)] rounded-lg font-semibold p-1 mt-2 px-4"
                            >
                              {e}
                            </p>
                          );
                        })}
                      </div>

                      <div className="whitespace-nowrap ml-4 md:ml-0">
                        <p className="flex flex-col justify-center items-center whitespace-nowrap py-1 px-3 border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)] font-medium">
                          <span>
                            L12{" "}
                            <span className="bg-white px-3 text-xs font-bold text-gray-800 ml-1">
                              {totalRoyaltyUsers[2]}
                            </span>
                          </span>{" "}
                          <span className="font-bold">
                            {royalty[2]}{" "}
                            <span className="text-[#f0c259]">BNB</span>
                          </span>
                        </p>
                        {royaltyUsers[2].map((e, i) => {
                          return (
                            <p
                              key={i}
                              className="whitespace-nowrap border-2 border-[rgba(124,240,89,0.16)] text-white bg-[rgba(124,240,89,0.14)] rounded-lg font-semibold p-1 mt-2 px-4"
                            >
                              {e}
                            </p>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-col w-full md:w-3/4 mt-8">
              <span className="font-mono font-semibold">
                Distribute Royalty
              </span>
              <button
                onClick={distributeRoyalty}
                className="bg-green-500 mt-2 text-white w-full px-4 py-2 text-sm font-bold rounded-sm flex justify-center items-center"
              >
                {loading5 ? (
                  <TailSpin height={16} color="white" />
                ) : (
                  <p>Distribute Royalty</p>
                )}
              </button>
            </div>

            {/* <div className="flex flex-col w-full md:w-3/4 mt-4">
                <span className='font-mono font-semibold'>Register</span>
                <input value={referrer} onChange={(e) => setReferrer(e.target.value)} placeholder='Enter Referrer' className='font-semibold w-full mt-2 outline-none bg-gray-200 text-gray-800 p-2 rounded-sm' />
                <input value={acc} onChange={(e) => setAcc(e.target.value)} placeholder='Enter Address' className='font-semibold w-full mt-2 outline-none bg-gray-200 text-gray-800 p-2 rounded-sm' />
                <button onClick={newRegister} className='bg-green-500 mt-2 text-white w-full px-4 py-2 text-sm font-bold rounded-sm flex justify-center items-center'>{loading3 ? <TailSpin height={16} color='white' /> : <p>Register</p>}</button>
            </div>

            <div className="flex flex-col w-full md:w-3/4 mt-4">
                <span className='font-mono font-semibold'>Upgrade</span>
                <input value={id2} onChange={(e) => setId2(e.target.value)} placeholder='Enter ID' className='font-semibold w-full mt-2 outline-none bg-gray-200 text-gray-800 p-2 rounded-sm' />
                <input value={level} onChange={(e) => setLevel(e.target.value)} placeholder='Enter Level' className='font-semibold w-full mt-2 outline-none bg-gray-200 text-gray-800 p-2 rounded-sm' />
                <button onClick={upgrade} className='bg-green-500 mt-2 text-white w-full px-4 py-2 text-sm font-bold rounded-sm flex justify-center items-center'>{loading ? <TailSpin height={16} color='white' /> : <p>Upgrade</p>}</button>
            </div> */}
          </div>
          <div className="w-full flex flex-col items-center">
            <div className="flex flex-col w-full md:w-3/4 mt-8 px-4 md:px-0">
              <span className="font-mono font-semibold">
                Dist Percent : {useAppState.bal2} %
              </span>
              <span className="font-mono font-semibold">
                Fee Contract Balance: {useAppState.bal3} BNB
              </span>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Admin;
